<template>
  <div style="height: 100%">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.42">
      <template #main>
        <TableMain name="one table" ref="ConsultPreDistributionTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :isBusy="isBusy" :show_toolbar_state="false"
          :hb_table_class="'hb_table_cpdistribut_class0'" :only_text="$t('common.show_all')"
          @only_methods="only_methods" @on_query="on_query" :show_toolbar_button="[0, 0, 0, 0, 0]"
          :table_height_adjust="-6" :show_email="true" :email_label="'send_email'" @email_invoke="SendEmail"
          @current_changed="current_changed">
          <template #query>
            <el-input clearable size="small" style="width: 300px" placeholder="请输入询价单编号"
              v-model="ConsultQuoteNum"></el-input>
          </template>
          <template #toolbar>
            <el-popover placement="right" title="提示" width="250" trigger="hover" content="默认显示未处理或未发邮件的数据！"
              style="border-color: red;">
              <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
            </el-popover>
          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain ref="ConsultPreDistributionTable2" :show_query_container="false" :show_date_picker="false"
          :fields="consult_handle_fields" :table_height_adjust="2" :title="table_title.title2"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar="false"
          :pager_count="5" :isBusy="isBusy2" :show_toolbar_state="false" :hb_table_class="'hb_table_cpdistribut_class1'"
          @on_cell_button_click="on_cell_button_click">
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="ConsultPreDistributionTable3" :fields="detail_fields" :show_query_container="false"
          :title="table_title.title3" :date_picker_label="date_picker_label" :table_height_adjust="2"
          :show_pagination="true" :show_toolbar="false" :show_filter="false" :pager_count="5" :isBusy="isBusy3"
          :loading_width="90" :show_toolbar_state="false" :show_toolbar_button="[0, 0, 1, 1, 0]" :check_state="true"
          :hb_table_class="'hb_table_cpdistribut_class2'" @on_input="distribution_on_input">
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="Detail_SaveData"
              :label="$t('common.save')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer3>
    <!-- 供应商附件管理 -->
    <el-dialog title="供应商附件列表" :visible.sync="accessoryVendVisible" width="60%" :top="'5vh'"
      :close-on-click-modal="false" @opened="bottomDialogOpened">
      <FileUpload ref="refVendAccessory" :accessoryCategory="'ConsultQuoteVend'" :showUpload="false"
        @setAccessory="bottomSetAccessory">
      </FileUpload>
    </el-dialog>
  </div>
</template>

<script>
import * as commonController from "../../controllers/commonController"
import * as ConsultQuoteConttroller from "../../controllers/mm/ConsultQuoteConttroller"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import QueryButton from "../components/base/QueryButton"
import SplitContainer3 from "../components/container/SplitContainer3"
import TableMain from "../components/table/TableMain"
import FileUpload from "../FileUpload.vue"

export default {
  components: {
    SplitContainer3,
    TableMain,
    QueryButton,
    FileUpload
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_consult_quote",
        title2: "table_consult_quote_vend_price",
        title3: "table_consult_quote_vend",
      },
      cqe_modal_title: "",
      fields: _.cloneDeep(ConsultQuoteConttroller.fields.consult_vend_pre_distribution_fields),
      // fields: _.cloneDeep(ConsultQuoteConttroller.fields.default),
      detail_fields: _.cloneDeep(ConsultQuoteConttroller.fields.consult_vend_fields),
      consult_handle_fields: _.cloneDeep(ConsultQuoteConttroller.fields.consult_handle_fields),
      qt_modal_title: "",
      ConsultQuoteNum: "",
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      InventListHis: [],
      vend_consult_data_his: [],
      filter_invent_name_key: "",
      filter_quote_task_key: "",
      all_role_users: [],
      dt1_his: [],
      current_vend_accessory: null,///当前供应商选中附件
      accessoryVendVisible: false,
    }
  },
  async created() {
    let unIncludeFields = ["DistributionRatio", "is_approved", "approved_by_username", "Accessory"]
    this.fields = _.filter(this.fields, (t) => {
      delete t.editable
      if (t.key == "ConsultQuoteNum") delete t.thStyle.display
      return !_.includes(unIncludeFields, t.key)
    })
    _.each(this.detail_fields, (t) => {
      if (t.key == "Description")
        delete t.editable

      return t.key !== "is_send_email" && t.key !== "is_done"
    })
    this.consult_handle_fields = _.filter(this.consult_handle_fields, (t) => { return t.key != "Accessory" && t.key != "ConsultQuoteNum" && t.key != "LineNum" })
    await this.getAllRoleUsers()
  },
  mounted() { },
  methods: {
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    only_methods(v) {
      this.on_query(this.$refs.ConsultPreDistributionTable1.SetData, false)
    },
    async on_query(set_data, isLoading = true) {
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }

      let p = { is_deleted: { "=": 0 } }
      if (this.ConsultQuoteNum != "") {
        p.ConsultQuoteNum = this.ConsultQuoteNum
      }
      let _result = await ConsultQuoteConttroller.methods.getDetailDataSql(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.filter(_.orderBy(_result[0], ["ConsultQuoteNum", "LineNum"], ["desc", "asc"]), { fcCheckCQApprovedIsOk: true, fcCheckCQHandleIsOk: true })
        if (!this.$refs.ConsultPreDistributionTable1.only_value)
          dt = _.filter(dt, (t) => { return !t.fcCheckCQPreDispatchIsOk || !t.is_send_email })
        let _dt = [], _keys = _.map(this.fields, "key")
        _.each(dt, (t) => {
          let m = {}
          _.each(_keys, (k) => {
            m[k] = t[k]
          })
          m._error = !t.fcCheckCQPreDispatchIsOk || !t.is_send_email
          m.ConsultQuoteId = t.ConsultQuoteId
          m.fcCheckCQPreDispatchIsOk = t.fcCheckCQPreDispatchIsOk
          m.is_send_email = t.is_send_email
          m.QuotationTaskDetailId = t.QuotationTaskDetailId
          m.dataAreaId = t.dataAreaId
          m.id = t.id
          if (_.findIndex(_dt, (o) => o.ConsultQuoteId == t.ConsultQuoteId && o.ItemId == t.ItemId) < 0)
            _dt.push(m)
        })
        this.dt1_his = dt
        this.$refs.ConsultPreDistributionTable1.SetData(_dt)
      }
      this.isBusy = false
    },
    async current_changed(old, current) {
      this.$refs.ConsultPreDistributionTable2.SetData([])
      this.$refs.ConsultPreDistributionTable3.SetData([])
      if (current) {
        this.isBusy2 = true
        await this.GetConsultVendPrice(current)
        this.isBusy2 = false
        this.isBusy3 = true
        await this.GetVendData(current)
        this.isBusy3 = false
      }
    },
    async GetVendData(current) {
      let p = { ConsultQuoteId: { "=": current.ConsultQuoteId }, is_deleted: { "=": 0 } }
      let _result = await ConsultQuoteConttroller.methods.getDataVend(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let detail_venders = []
        _.each(_result[0], (t) => {
          let m = _.find(_.cloneDeep(this.$store.state.biz_data.baseData.Vender), { AccountNum: t.AccountNum })
          m.id = t.id
          m.DistributionRatioJson = []
          m.Description = t.Description
          let _distributionRatio = 0, _distributionDes = ""
          if (t.DistributionRatio && t.DistributionRatio != "") {
            m.DistributionRatioJson = JSON.parse(t.DistributionRatio)
            let rm = _.find(m.DistributionRatioJson, { ItemId: current.ItemId })
            if (rm) {
              _distributionRatio = rm.DistributionRatio
              _distributionDes = rm.DistributionDes
            }
          }

          m.DistributionRatio = _distributionRatio
          m.DistributionDes = _distributionDes
          m.is_approved = t.is_approved
          m.approved_by_username = t.approved_by_username
          if (m) detail_venders.push(m)
        })
        this.$refs.ConsultPreDistributionTable3.SetData(_.orderBy(detail_venders, ["id"], ["asc"]))
      }
    },
    async GetConsultVendPrice(m) {
      let _result = await ConsultQuoteConttroller.methods.getConsultVendPrice({ ConsultQuoteId: m.ConsultQuoteId, ItemId: m.ItemId })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (t) => {
          t.AccessoryVendCount = 0
          if (t.VendAccessory && t.VendAccessory != "")
            t.AccessoryVendCount = JSON.parse(t.VendAccessory).length
        })
        this.vend_consult_data_his = _.cloneDeep(_result[0])
        this.$refs.ConsultPreDistributionTable2.SetData(_result[0])
      }
    },
    ///明细行输入事件
    distribution_on_input(data) {
      if (data.field.key == "DistributionRatio") {
        let lt = _.each(_.cloneDeep(this.$refs.ConsultPreDistributionTable3.my_data), (t) => {
          if (!t.DistributionRatio) t.DistributionRatio = 0
          else t.DistributionRatio = parseFloat(t.DistributionRatio)

        })
        let total_rate = _.sumBy(lt, "DistributionRatio")
        if (total_rate > 100) {
          let _rate = 100 - (total_rate - data.item.DistributionRatio)
          data.item.DistributionRatio = _rate
        }
      }
    },
    async Detail_SaveData(cb) {
      //勾选保存
      let detail_data = this.$refs.ConsultPreDistributionTable3.my_data ///911修改为保存列表所有供应商
      if (detail_data.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(null)
        return
      }

      let mainCurrent = this.$refs.ConsultPreDistributionTable1.GetCurrentItem()
      let p = { edit: [] }, msg = ""
      _.each(detail_data, (t) => {
        if (msg == "" && !t.is_approved && t.DistributionRatio >= 0)
          msg = "抱歉，只能针对审批后的单据进行分配！"
        // t.DistributionRatioJson = JSON.parse(t.DistributionRatio)
        // t.DistributionRatioJson.push({
        //   ItemId: mainCurrent.ItemId,
        //   DistributionRatio: t.DistributionRatio,
        //   DistributionDes: t.DistributionDes
        // })
        if (t.DistributionRatioJson.length > 0) {
          let mt = _.find(t.DistributionRatioJson, { ItemId: mainCurrent.ItemId })// ConsultQuoteDetailId: mainCurrent.id
          if (mt) {
            mt.DistributionRatio = t.DistributionRatio
            mt.DistributionDes = t.DistributionDes
            mt.ConsultQuoteDetailId = mainCurrent.id
          }
          else {
            t.DistributionRatioJson.push({
              // ConsultQuoteDetailId: mainCurrent.id,
              ItemId: mainCurrent.ItemId,
              DistributionRatio: t.DistributionRatio,
              DistributionDes: t.DistributionDes
            })
          }
        }
        else {
          t.DistributionRatioJson.push({
            // ConsultQuoteDetailId: mainCurrent.id,
            ItemId: mainCurrent.ItemId,
            DistributionRatio: t.DistributionRatio,
            DistributionDes: t.DistributionDes
          })
        }
        let m = {
          id: t.id,
          DistributionRatio: JSON.stringify(t.DistributionRatioJson),
          DistributionDes: t.DistributionDes
        }
        if (t.id != "") p.edit.push(m)
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }

      let rt = await ConsultQuoteConttroller.methods.saveDataVend(p)
      if (rt) {
        await this.GetVendData(mainCurrent)
        // ///打样报价：处理成功后将采购预分配添加到打样分配中
        // if (mainCurrent.quotationType === '打样报价') {
        //   let detail_item = detail_data.find(t => t.DistributionRatio && t.DistributionRatio >= 100)
        //   let vend_price_item = this.$refs.ConsultPreDistributionTable2.my_data.find(t => t.AccountNum === detail_item.AccountNum && t.quotationType === mainCurrent.quotationType)

        //   let p = { id: { "=": mainCurrent.QuotationTaskDetailId } }
        //   let _result = await QuotationTaskController.methods.getDetailData(p)
        //   if (!_.isNull(_result) && _result && _result.length > 0) {
        //     let quotation_detail_item = _result[0][0]
        //     let item = {
        //       QuotationTaskDetailId: mainCurrent.QuotationTaskDetailId,
        //       dataAreaId: mainCurrent.dataAreaId,
        //       ItemId: quotation_detail_item.ItemId,
        //       NameAlias: quotation_detail_item.NameAlias,
        //       BatchQty: quotation_detail_item.BatchQty,
        //       Qty: quotation_detail_item.BatchQty ? quotation_detail_item.BatchQty : quotation_detail_item.FromBatchQty,
        //       Price: quotation_detail_item.Price,
        //       AccountNum: vend_price_item.AccountNum,
        //       AccountName: vend_price_item.AccountName,
        //       PerPrice: vend_price_item.Price,
        //       VendAccessory: vend_price_item.VendAccessory,
        //       DistributionRate: detail_item.DistributionRatio ? Number(detail_item.DistributionRatio) : 0,
        //       DistributionRatePre: detail_item.DistributionRatio ? Number(detail_item.DistributionRatio) : 0
        //     }
        //     await QuotationTaskHandleController.methods.saveDistributionProofingData({ add: [item] })
        //   }
        // }
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    ///发送报价申请处理邮件
    async SendEmail() {
      let selected_items = this.$refs.ConsultPreDistributionTable1.GetSelectedItems()
      ///检查
      if (selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }

      let is_ok = await this.msgModal(this.$t("notify.is_send_email"))
      if (!is_ok) {
        return
      }
      let sended_dt = _.filter(selected_items, { is_send_email: true })
      if (sended_dt.length > 0) {
        let ask = await this.$confirm("选择项中存在已发邮件数据，是否继续？").then(t => { return true }).catch(t => { return false })
        if (!ask) return
      }
      ///处理大货邮件
      {
        let p = _.map(selected_items.filter(t => t.quotationType !== '打样报价'), (t) => { return { id: t.ConsultQuoteId } })
        await commonController.handleEmailNotify(_.uniqBy(p, 'id'), "consult_complated", this, this.all_role_users, "email_get_consult_complated")
      }
      ///处理打样邮件
      {
        ///新处理方式
        let p = _.map(selected_items.filter(t => t.quotationType === '打样报价'), (t) => { return { id: t.ConsultQuoteId } })
        await commonController.handleEmailNotify(_.uniqBy(p, 'id'), "consult_complated_proofing", this, this.all_role_users, "email_get_consult_complated")
        ///旧处理方式：发邮件给系统配置里配置的：打样报价采购预分配完成后邮件通知人
        // let _profit_m = _.find(this.$store.state.biz_data.baseData.SystemSetting, { code: "email_notifier" })
        // if (_profit_m && _profit_m.setting_value != "") {
        //   let m = JSON.parse(_profit_m.setting_value)
        //   if (m.PurchDistributionQuoteProofingEmailNotifier && m.PurchDistributionQuoteProofingEmailNotifier.length > 0) {
        //     let eusers = []
        //     let roles = _.map(this.$store.state.biz_data.userInfo.user_roles_privileges.roles, "code")
        //     for (var i in m.PurchDistributionQuoteProofingEmailNotifier) {
        //       if (_.includes(roles, m.PurchDistributionQuoteProofingEmailNotifier[i])) {
        //         let _result = await RoleManageController.methods.GetRoleUsers(-1, m.purchEmailNotifier[i])
        //         _result = _.filter(_result, { is_sys: false })
        //         if (_result && _result.length > 0) {
        //           _.each(_result, (t) => {
        //             eusers.push(t)
        //           })
        //         }
        //       }
        //       else
        //         eusers.push(m.PurchDistributionQuoteProofingEmailNotifier[i])
        //     }
        //     let p = _.map(selected_items.filter(t => t.quotationType === '打样报价'), (t) => { return { id: t.ConsultQuoteId } })
        //     await commonController.handleEmailNotify(_.uniqBy(p, 'id'), "consult_complated_proofing", this, this.all_role_users, "email_get_consult_complated")
        //   }
        // }
      }

      let p1 = { edit: [] }
      _.each(selected_items, (t) => {
        t.is_send_email = true
        t._error = false
        p1.edit.push({ id: t.id, is_send_email: true })
        ///取消按整个询价单发邮件20240913
        // let dt = _.filter(this.dt1_his, { ConsultQuoteId: t.ConsultQuoteId })
        // if (dt.length > 0) {
        //   _.each(dt, (m) => {
        //     p1.edit.push({ id: m.id, is_send_email: true })
        //   })
        // }
      })
      await ConsultQuoteConttroller.methods.saveDetailData(p1)
      // await this.on_query(this.$refs.ConsultPreDistributionTable1.SetData, false)
    },
    //#region 供应商附件
    async on_cell_button_click(data) {
      this.current_vend_accessory = data.item
      if (data.field.key == "VendAccessory") this.accessoryVendVisible = true
    },
    bottomDialogOpened() {
      this.$refs.refVendAccessory.getAccessory(this.current_vend_accessory.VendAccessory, this.current_vend_accessory.ItemId)
    },
    bottomSetAccessory(data) {
      this.current_vend_accessory.Accessory = data
    }
    //#endregion
  },
}
</script>
<style>
.hb_table_cpdistribut_class0 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 80rem;
}

.hb_table_cpdistribut_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 260rem;
}

.hb_table_cpdistribut_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 95rem;
}
</style>
